import React from 'react'
import Spinner from 'react-bootstrap/Spinner'
import styled from 'styled-components'

export default function Loading({ width, height }) {
  return (
    <Container>
      {(height && width != '') || undefined ? (
        <Spinner
          animation="border"
          role="status"
          style={{ width: `${width}rem`, height: `${height}rem` }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      ) : (
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      )}
    </Container>
  )
}

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`
